window.bootstrap = require("bootstrap");
import { Carousel } from "bootstrap";
import $ from "jquery";

$(".hero-desktop-buttons .menu li.menu-item-has-children a").click(function (
	e
) {
	$(this).toggleClass("clicked");
});
